import { Component, OnInit, Input, NgZone, Output, EventEmitter } from '@angular/core';
import { UntypedFormGroup, UntypedFormControl, FormBuilder, Validators } from '@angular/forms';
import { Message } from 'primeng/api';
import { ErrorBindingService } from './../../services/error-binding.service';
import { CommonBindingDataService } from './../../services/common-binding-data.service';
import { UserCommonService } from './../../services/user-common.service';
import { AppSettings } from '../../app.settings';
import { UiService } from '../../services/ui.service';


@Component({
  selector: 'app-change-password',
  templateUrl: './change-password.component.html'
})
export class ChangePasswordComponent implements OnInit {
  errorMessage: Message[] = [];
  @Input() changePasswordPopup: boolean;
  @Output() isShowChangePassword: EventEmitter<any> = new EventEmitter();
  inputType = 'password';
  cnfinputType = 'password';
  oldInputType = 'password';
  changePasswordErrors = [
    {
      oldPassword: false,
      newPassword: false,
      newConfirmPassword: false,
    }
  ];

  chagePasswordForm = new UntypedFormGroup({
    oldPassword: new UntypedFormControl(),
    newPassword: new UntypedFormControl(),
    newConfirmPassword: new UntypedFormControl()
  });

  constructor(
    private formBuilder: FormBuilder,
    private signOutService: UserCommonService,
    private commonService: CommonBindingDataService,
    private errorBindingService: ErrorBindingService,
    private uiService: UiService
  ) { }

  ngOnInit() {
    this.chagePasswordForm = this.formBuilder.group({
      oldPassword: ['', [Validators.required, Validators.pattern(AppSettings.ONLY_SPACE_NOT_ALLOWED_PATTERN)]],
      newPassword: ['', [Validators.required, Validators.minLength(8),
      Validators.pattern(AppSettings.PASSWORD_VALIDATIONS)]],
      newConfirmPassword: ['', [Validators.required, Validators.minLength(8),
      Validators.pattern(AppSettings.PASSWORD_VALIDATIONS)]]
    });
  }

  passwordNotMatched() {
    if (this.chagePasswordForm.controls.newPassword.value !== this.chagePasswordForm.controls.newConfirmPassword.value) {
      const error = {
        general: [
          {
            message: this.commonService.getLabel('error_new_confirm_password_not_match')
          }
        ]
      };
      this.errorBindingService.onAPIValidationError(error, this.changePasswordErrors);
    } else {
      return true;
    }
  }

  requestData() {
    return {
      oldPassword: this.commonService.encrypt(this.chagePasswordForm.controls.oldPassword.value),
      newPassword: this.commonService.encrypt(this.chagePasswordForm.controls.newPassword.value),
    };
  }
  doChangePassword() {
    const passwordVerified = this.passwordNotMatched();
    if (passwordVerified) {
      const data = this.requestData();
      const c = this;
      this.signOutService.passwordChange(JSON.stringify(data)).subscribe(results => {
        this.uiService.showMessage(results.general[0].message, AppSettings.MESSAGE_TYPE.SUCCESS);
        setTimeout(() => {
          this.chagePasswordForm.reset();
          this.isShowChangePassword.emit(false);
        }, 2000);
      }, (error) => {
        this.uiService.showMessage(error.general[0].message, AppSettings.MESSAGE_TYPE.ERROR);
        this.errorBindingService.onAPIValidationError(error, this.changePasswordErrors);
      });
    }
  }

  onCancel() {
    this.chagePasswordForm.reset();
    this.isShowChangePassword.emit(false);
  }

  tooglePasswordType() {
    if (this.inputType === 'password') {
      this.inputType = 'text';
    } else {
      this.inputType = 'password';
    }
  }

  toogleCnfPasswordType() {
    if (this.cnfinputType === 'password') {
      this.cnfinputType = 'text';
    } else {
      this.cnfinputType = 'password';
    }
  }

  toogleOldPasswordType() {
    if (this.oldInputType === 'password') {
      this.oldInputType = 'text';
    } else {
      this.oldInputType = 'password';
    }
  }

}
